<template>
  <div class="radio-sel">
    <div class="line">
      <div class="title" :class="{ required: required }">{{ title }}：</div>
      <div
        v-for="(item, index) in options"
        @click="handleClick(item)"
        class="radio"
        :key="index"
      >
        <img
          v-if="value === item.value"
          src="~@/assets/img/plc/radio-a.png"
          alt=""
        />
        <img v-else src="~@/assets/img/plc/radio.png" alt="" />
        <span>{{ item.label }}</span>
      </div>
      <div style="flex: 1">
        <slot name="right"></slot>
      </div>
    </div>
    <div class="line mt-8">
      <slot name="bottom"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    options: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: "",
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(v) {
      this.$emit("change", v.value);
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-sel {
  border-radius: 12px;
  background: #ffffff;
  margin-top: 16px;
  padding: 16px 28px;
}
.line {
  display: flex;
  align-items: center;
}
.title {
  font-size: 16px;
  font-weight: bold;
  color: #000000;
  margin-right: 16px;
  &.required::before {
    content: "*";
    font-size: 16px;
    font-weight: bold;
    color: #ff4c2b;
  }
}
.radio {
  cursor: pointer;
  margin-right: 20px;
  font-size: 14px;
  color: #3d3d3d;
  img {
    width: 12px;
    height: 12px;
    margin-right: 4px;
  }
}
.mt-8{
  margin-top: 8px;
}
</style>
